import React from 'react';

import styles from './StatisticsUse.module.scss';
import { Accordion } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import UseLeash from './UseLeash/UseLeash';
import UseLoose from './UseLoose/UseLoose';
import UseHare from './UseHare/UseHare';

function StatisticsUse(props: StatisticsUseProps) {
    const t = useTranslate();

    const [hasDataLeash, setHasDataLeash] = React.useState<boolean>(false);
    const [hasDataLoose, setHasDataLoose] = React.useState<boolean>(false);
    const [hasDataHare, setHasDataHare] = React.useState<boolean>(false);

    React.useEffect(() => {
        props.onDataLoaded?.(hasDataLeash || hasDataLoose || hasDataHare);
    }, [hasDataLeash, hasDataLoose, hasDataHare]);

    return (
        <div className={styles.statisticsuse}>
            <Accordion className={styles.accordion} defaultActiveKey="0">
                <Accordion.Item className={styles.accordionitem} eventKey="0" style={{ display: hasDataLeash ? "block" : "none" }}>
                    <Accordion.Header className={styles.accordionheader}>{t("statistics.areas.use.leash.title")}</Accordion.Header>
                    <Accordion.Body>
                        <UseLeash
                            onDataLoaded={(hasData) => {
                                if (hasData) {
                                    setHasDataLeash(true);
                                } else {
                                    setHasDataLeash(false);
                                }
                            }}
                        />
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item className={styles.accordionitem} eventKey="1" style={{ display: hasDataLoose ? "block" : "none" }}>
                    <Accordion.Header className={styles.accordionheader}>{t("statistics.areas.use.loose.title")}</Accordion.Header>
                    <Accordion.Body>
                        <UseLoose
                            onDataLoaded={(hasData) => {
                                if (hasData) {
                                    setHasDataLoose(true);
                                } else {
                                    setHasDataLoose(false);
                                }
                            }}
                        />
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item className={styles.accordionitem} eventKey="2" style={{ display: hasDataHare ? "block" : "none" }}>
                    <Accordion.Header className={styles.accordionheader}>{t("statistics.areas.use.hare.title")}</Accordion.Header>
                    <Accordion.Body>
                        <UseHare
                            onDataLoaded={(hasData) => {
                                if (hasData) {
                                    setHasDataHare(true);
                                } else {
                                    setHasDataHare(false);
                                }
                            }}
                        />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
}

class StatisticsUseProps {
    onDataLoaded?: (hasData: boolean) => void;
}

export default StatisticsUse;